module.exports = __webpack_public_path__ + "img/pd-img-head1.e2b42afd.png";